var AWSDataEmployeesServiceModule = /** @class */ (function () {
    function AWSDataEmployeesServiceModule() {
    }
    return AWSDataEmployeesServiceModule;
}());
export { AWSDataEmployeesServiceModule };
